import BaseButton, { ButtonProps as BaseButtonProps } from 'carbon-react/lib/components/button';
import styled, { css } from 'styled-components';
import { getEnhancedButtonType } from '../hooks';

const embeddedStyle = css`
  min-height: 32px;
`;

const StyledButton = styled(BaseButton)`
  ${embeddedStyle}
`;

export interface ButtonProps extends BaseButtonProps {
  tabIndex?: number;
}

const Button = ({ buttonType: enhancedButtonType, ref, ...props }: ButtonProps & { ref?: React.Ref<HTMLButtonElement> }) => {
  const buttonType = getEnhancedButtonType(enhancedButtonType);
  return <StyledButton ref={ref} buttonType={buttonType} {...props} />;
};

export default Button;
